const doc = [({"body":"font-default grid grid-rows-1fr-1fr-auto h-100%", "container":"relative p-t-56 p-b-56 md:p-t-72 md:p-b-72\n"})];
module.exports = doc.length <= 1 ? doc[0] : doc;